import img1 from "../assets/website/sabiSave.png";
import img2 from "../assets/website/tulay.png";
import img3 from "../assets/website/tukksho.png";
import img4 from "../assets/website/TonyWiggins.png";
import img5 from "../assets/website/usApt.png";
import img6 from "../assets/website/Kazza.png";
import img10 from "../assets/website/firstInfrastructure.png";
import img100 from "../assets/website/Busayo.png";
import img99 from "../assets/website/Jmofs.png";
import img98 from "../assets/website/Omolaja.png";
import img97 from "../assets/website/KimsKoffee.png";

export const ProjectList = [
  {
    id: 2,
    title: "Tulay Africa",
    expalain:
      "Tulay Africa streamlines raw material supply chain by leveraging expertise, technology, and local knowledge to connect African businesses to global opportunities. Built with React.js",
    link: "https://tulay.africa/",
    img: img2,
    git: "",
    live: true,
  },

  {
    id: 5,
    title: "TWCLM",
    expalain:
      "Toyins Centre for Leadership & Mentoring Initiative is a Nigerian Non- Tprofit organization founded in 2012. Built with React.js",
    link: "https://www.twclm.org/",
    img: img4,
    git: "",
    live: true,
  },
  {
    id: 7,
    title: "FICL",
    expalain:
      "First Infrastructure Contractors Limited has been an active player in the Civil, Built and Natural Environmental Engineering Construction. Built with React.js",
    link: "https://firstinfrastructureng.com/",
    img: img10,
    git: "",
    live: true,
  },
  {
    id: 3,
    title: "Kazza",
    expalain:
      "Kazza helps customers pay for anything from anywhere with their wallets. Built with Next.js",
    link: "https://www.mykazza.com/",
    img: img6,
    git: "",
    live: true,
  },
  {
    id: 1,
    title: "Sabi Save",
    expalain:
      "SabiSave is a digital platform that provides traders and artisans with a convenient and secure way to save daily and manage their finances from their mobile phones. Built with React.js",
    link: "https://sabisave.com/",
    img: img1,
    git: "",
    live: true,
  },
  {
    id: 4,
    title: "Use Apt",
    expalain:
      "Aptly Connecting You to Exclusive Homes with Local Expertise and Tailored Experiences in Portugal. Built with WordPress",
    link: "https://useapt.com/",
    img: img5,
    git: "",
    live: true,
  },
  {
    id: 100,
    title: "Busayo",
    expalain:
      "An Ecommerce website that enables slaes of local nigeian attairs to a global market. Built with Wordpress",
    link: "https://shopbusayo.com/",
    img: img100,
    git: "",
    live: true,
  },

  {
    id: 6,
    title: "tukshopp.",
    expalain:
      "Get your Food delivered to your doorstep. Everything you need, delivered when you need it. Built with Next.js",
    link: "https://tukshopp.ng/",
    img: img3,
    git: "",
    live: true,
  },

  {
    id: 98,
    title: "Omolaja.",
    expalain:
      "Barrister Omolaja Agbeleshe @ O. Agbeleshebioba & Co. (Lord's will chambers) Expert In Legal Services | Immigration Laws | Property Consultant | Human Rights Advocate. Made with Next.js",
    link: "https://omolaja.vercel.app/",
    img: img98,
    git: "",
    live: true,
  },
  {
    id: 97,
    title: "Kims Koffee.",
    expalain:
      "Kim's Coffee is a quality 100% Arabica Coffee beans grown in the highlands of Plateau state in Central Nigeira. Built with Next.js",
    link: "https://kims-coffee-prod.vercel.app/",
    img: img97,
    git: "",
    live: true,
  },
  {
    id: 99,
    title: "Jmofs.",
    expalain:
      "Explore our collection of 10+ courses to find the perfect shoe-making course for you. Built with Next.js",
    link: "",
    img: img99,
    git: "https://jmofs.net/",
    live: true,
  },
];
